//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { DownloadInvoiceDocumentRequest } from './models/DownloadInvoiceDocumentRequest';
import type { FileResponse } from './models/FileResponse';
import type { InvoicePaginationNextResult } from './models/InvoicePaginationNextResult';
import type { InvoicePaginationResult } from './models/InvoicePaginationResult';
import type { ManagementCompanyResponse } from './models/ManagementCompanyResponse';
import type { SearchInvoicesRequest } from './models/SearchInvoicesRequest';
import { Utilities } from './Utilities';

export class InvoicesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getInvoices: (
			siren: string,
			contractId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/contractId/{contractId}';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (contractId === undefined || contractId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('contractId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{contractId}', encodeURIComponent(String(contractId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        search: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/do-get-search';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        downloadInvoice: (
			siren: string,
			documentId?: string,
			invoiceId?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/download?';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (documentId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('documentId'));
            } else if (documentId !== undefined) {
                clientRequestUrl += `documentId=${encodeURIComponent(String(documentId))}&`;
            }
            if (invoiceId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('invoiceId'));
            } else if (invoiceId !== undefined) {
                clientRequestUrl += `invoiceId=${encodeURIComponent(String(invoiceId))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        downloadInvoices: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/do-download';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getManagementCompany: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/invoices/{siren}/management-company';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get invoices
     * @return OK
     */
    async getInvoices(
        siren: string,
        contractId: string,
    ): Promise<InvoicePaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getInvoices(
            siren,
            contractId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<InvoicePaginationResult>(_response, false, ['termDate']);
    }

    /**
     * Download multiple invoices document
     * @param body (optional) 
     * @return OK
     */
    async search(
        siren: string,
        body?: SearchInvoicesRequest,
    ): Promise<InvoicePaginationNextResult> {
        const clientRequestUrl = this.baseUrl + this.routes.search(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<InvoicePaginationNextResult>(_response, false, ['termDate']);
    }

    /**
     * Download invoice document
     * @param documentId (optional) 
     * @param invoiceId (optional) 
     * @return OK
     */
    async downloadInvoice(
        siren: string,
        documentId?: string,
        invoiceId?: string,
    ): Promise<FileResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.downloadInvoice(
            siren,
            documentId,
            invoiceId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<FileResponse>(_response, true, []);
    }

    /**
     * Download multiple invoices document
     * @param body (optional) 
     * @return OK
     */
    async downloadInvoices(
        siren: string,
        body?: DownloadInvoiceDocumentRequest[],
    ): Promise<FileResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.downloadInvoices(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<FileResponse>(_response, true, []);
    }

    /**
     * Get Default Management Company
     * @return OK
     */
    async getManagementCompany(
        siren: string,
    ): Promise<ManagementCompanyResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getManagementCompany(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ManagementCompanyResponse>(_response, false, []);
    }
}
